import React, { useEffect, useMemo } from "react";
import { CandidateDetail } from "../../../../models/candidate-detail.model";
import { SectionBlock } from "../../talent.styled";
import Avatar from "../avatar/avatar";
import { LockedContent } from "../locked-content/locked-content";
import {
  SocialIcon,
  SocialNetwork,
  SocialNetworkLink,
  SocialNetworkList
} from "../social-networks/social-networks.styled";
import Contact from "./../../components/contacts/contacts";
import { Content, TranslateButton } from "./header.styled";
import { validExternalUrl } from "../../../../utils/string.utils";
import { BsTranslate } from "react-icons/bs";
import { useTranslation } from "react-i18next";


interface HeaderProps {
  candidate?: CandidateDetail | null;
  isLocked: boolean;
  translate?: boolean;
  setTranslate?: (translate: boolean) => void;
}

const Header: React.FC<HeaderProps> = ({ candidate, isLocked, translate, setTranslate }) => {
  const { t, i18n } = useTranslation();
  const isPtBr = useMemo(() => {
    return i18n.language.toLowerCase() === 'pt-br';
  }, [i18n.language]);
  
  useEffect(() => {
    if(isPtBr) {
      setTranslate && setTranslate(false)
    }
  }, [isPtBr, setTranslate]);

  return (
    <Content>
      <SectionBlock header="header">
        <Avatar candidate={candidate} isLocked={isLocked} />
      </SectionBlock>
      {(!isPtBr && false) && (
        <TranslateButton 
          active={translate} 
          onClick={() => setTranslate && setTranslate(!translate)}
        >
          <span>{t('translateGoogleTooltip')}</span>
          <BsTranslate />
        </TranslateButton>
      )}
      {candidate?.linkedin && (
        <SectionBlock header="header">
          <SocialNetworkList>
            <SocialNetwork>
              <SocialNetworkLink
                href={validExternalUrl(candidate.linkedin)}
                target="_blank"
                rel="noreferrer"
              >
                <SocialIcon
                  src="/assets/img/linkedin.svg"
                  title="LinkedIn"
                />
              </SocialNetworkLink>
            </SocialNetwork>
          </SocialNetworkList>
        </SectionBlock>
      )}
      {candidate?.github && (
        <SectionBlock header="header">
          {isLocked ? (
            <>
              <LockedContent />
            </>
          ) : (
            <SocialNetworkList>
              {candidate?.github && (
                <SocialNetwork>
                  <SocialNetworkLink
                    href={validExternalUrl(candidate.github)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <SocialIcon src="/assets/img/github.svg" title="Github" />
                  </SocialNetworkLink>
                </SocialNetwork>
              )}
            </SocialNetworkList>
          )}
        </SectionBlock>
      )}

      <SectionBlock header="header">
        <Contact candidate={candidate} isLocked={isLocked} />
      </SectionBlock>
    </Content>
  );
};

export default Header;
